import classNames from 'classnames';
import React from 'react';
import { usePatchedDropdownMenu } from '../../../utils/usePatchedDropdownMenu';
import { ValidatingFormContext } from '../../validatingElements';

interface IRamsOptions {
    text: string;
    textLine2?: string;
    textLine3?: string;
    value: string;
    priorityValue?: string;
}

type Props = {
    name: string;
    topLabel: string;
    header: string;
    subText: string;
    options: IRamsOptions[];
};

export function RamssheepDropdownFmeca(props: Props) {
    const menuItemsAmount = Number(!!props.header) + props.options.length;
    const { buttonProps, itemProps, isOpen, setIsOpen } = usePatchedDropdownMenu(menuItemsAmount);
    const classes = classNames('btn-group', { open: isOpen });

    return (
        <ValidatingFormContext.Consumer>
            {(state) => (
                <span style={{ float: 'left' }} className="mh10">
                    {props.topLabel && (
                        <div className="pv5 ph10">
                            <strong>{props.topLabel}</strong>
                        </div>
                    )}
                    <div className={classes}>
                        <button
                            {...buttonProps}
                            className={`btn btn-primary btn-sm dropdown-toggle rams-button rams${getPriorityValue(
                                props.options,
                                state.item[props.name],
                            )}`}
                            data-toggle="dropdown"
                            type="button"
                            onKeyPress={(e) => {
                                if (e.key > '0' && e.key <= props.options.length.toString()) {
                                    void state.onChange(props.name, e.key);
                                } else if (e.key === '0') {
                                    void state.onChange(props.name, null);
                                }
                            }}
                        >
                            {state.item[props.name] || '_'}
                        </button>
                        <ul className="dropdown-menu pull-right" role="group">
                            {props.header && (
                                <li
                                    {...itemProps[0]}
                                    onClick={() => {
                                        setIsOpen(false);
                                        void state.onChange(props.name, null);
                                    }}
                                    className="edit-element"
                                    style={{ color: '#000' }}
                                >
                                    <a className="cursor">
                                        <strong>{props.header}</strong>
                                        {props.subText && <div className="fs12 text-muted">{props.subText}</div>}
                                    </a>
                                </li>
                            )}
                            {props.options.map((option, i) => (
                                <li
                                    key={i}
                                    {...itemProps[i + Number(!!props.header)]}
                                    className={option.value === state.item[props.name] ? 'bg-light darker' : ''}
                                    onClick={() => {
                                        setIsOpen(false);
                                        void state.onChange(props.name, option.value);
                                    }}
                                >
                                    <a className="cursor edit-element">
                                        {option.value === props.name ? (
                                            <strong>
                                                {option.value}:&nbsp;&nbsp;{option.text}
                                            </strong>
                                        ) : (
                                            <>
                                                {option.value}:&nbsp;&nbsp;{option.text}
                                                {option.textLine2 && <div>{option.textLine2}</div>}
                                                {option.textLine3 && <div>{option.textLine3}</div>}
                                            </>
                                        )}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </span>
            )}
        </ValidatingFormContext.Consumer>
    );
}

function getPriorityValue(options: IRamsOptions[], value: any) {
    if (value) {
        const optionItem = options.find((item) => item.value === value.toString());
        if (optionItem) {
            return optionItem.priorityValue;
        }
        return '0';
    }
    return '0';
}
